export default "/images/vendor/flag-icons/flags/4x3/bj.svg?b04c72b67773f10058a853b2a3991192";